// eslint-disable-next-line @typescript-eslint/ban-types
export function proxyObjectToDefaults<D extends {}, K extends keyof D>(obj: D, defaults: D): D {
  const handler = {
    get(target: D, name: Extract<K, string | symbol>) {
      if (target[name] !== null && target[name] !== undefined) {
        if (typeof target[name] === 'object') return proxyObjectToDefaults(target[name] as D, defaults[name] as D);
        else return target[name];
      } else return defaults[name];
    }
  };
  return new Proxy(obj, handler);
}
